export default [
  {
    path: '/fcr/:farmId/:shedId/:flockId',
    name: 'flock-fcr',
    component: () => import('@/views/apps/fcr/FlockFcr.vue'),
    meta: { pageTitle: 'FCR Analysis' },
  },
  {
    path: '/profit-predictor/:farmId/:shedId/:flockId',
    name: 'profit-predictor',
    component: () => import('@/views/apps/profit-predictor/ProfitPredictor.vue'),
    meta: { pageTitle: 'Profit Predictor' },
  },
  {
    path: '/market-prices',
    name: 'market-prices',
    component: () => import('@/views/apps/market-prices/MarketPriceList.vue'),
    meta: { pageTitle: 'Market Prices' },
  },
  {
    path: '/disease-alerts',
    name: 'disease-alerts',
    component: () => import('@/views/apps/disease-alerts/DiseaseAlertList.vue'),
    meta: { pageTitle: 'Disease Alerts' },
  },
  {
    path: '/notification-settings',
    name: 'notification-settings',
    component: () => import('@/views/apps/notification-settings/NotificationSettings.vue'),
    meta: { pageTitle: 'Alert Settings' },
  },
  {
    path: '/vaccination-schedule/:farmId/:shedId/:flockId',
    name: 'vaccination-schedule',
    component: () => import('@/views/apps/vaccination-schedule/VaccinationScheduleList.vue'),
    meta: { pageTitle: 'Vaccination Schedule' },
  },
  {
    path: '/health-scores',
    name: 'health-scores',
    component: () => import('@/views/apps/health-score/HealthScoreDashboard.vue'),
    meta: { pageTitle: 'Flock Health Scores' },
  },
  {
    path: '/health-score/:farmId/:shedId/:flockId',
    name: 'flock-health-score',
    component: () => import('@/views/apps/health-score/FlockHealthScore.vue'),
    meta: { pageTitle: 'Flock Health Score' },
  },
  {
    path: '/flock-pnl/:farmId/:shedId/:flockId',
    name: 'flock-pnl',
    component: () => import('@/views/apps/flock-pnl/FlockPnl.vue'),
    meta: { pageTitle: 'Flock P&L' },
  },
  {
    path: '/benchmarking',
    name: 'benchmarking',
    component: () => import('@/views/apps/benchmarking/BenchmarkingDashboard.vue'),
    meta: { pageTitle: 'Farm Benchmarking' },
  },
  {
    path: '/integrators',
    name: 'integrators',
    component: () => import('@/views/apps/integrators/IntegratorList.vue'),
    meta: { pageTitle: 'Integrators' },
  },
  {
    path: '/integrators/:integratorId/contracts',
    name: 'integrator-contracts',
    component: () => import('@/views/apps/integrators/IntegratorContracts.vue'),
    meta: { pageTitle: 'Integrator Contracts' },
  },
  {
    path: '/integrator-contracts/:contractId/settlements',
    name: 'integrator-settlement',
    component: () => import('@/views/apps/integrators/IntegratorSettlement.vue'),
    meta: { pageTitle: 'Settlement' },
  },
  {
    path: '/consultations',
    name: 'consultations',
    component: () => import('@/views/apps/vet-consultation/ConsultationList.vue'),
    meta: { pageTitle: 'Vet Consultations' },
  },
  {
    path: '/consultations/:consultationId',
    name: 'consultation-detail',
    component: () => import('@/views/apps/vet-consultation/ConsultationDetail.vue'),
    meta: { pageTitle: 'Consultation' },
  },
]
